import { FishGroupStyles } from './FishGroup.types'

const makeStyles = (): FishGroupStyles => ({
	fishGroup: {
		margin: '0px 50px 0px 0px'
	}
})

export default makeStyles
